import { Component } from '@/types/component';

export const Controls: Component<{}> = ({ children }) => {
  return <div className="flex flex-wrap gap-6 bg-primary-100 p-3">{children}</div>;
};
